import * as PIXI from "pixi.js";
import {drawRoundedRect} from "../../utils/graphics";
import {ApiService, gameData} from "../../utils/pixiApp";

const sizes = {
    web: {
        nodalWidth: 342,
        modalHeight: 202,
        contentWidth: 301
    }
}

const titleStyle = new PIXI.TextStyle({
    fontSize: 24,
    fontWeight: 600,
    fill: '#0b0b0b',
    lineHeight: 24,
    fontFamily: "Montserrat, sans-serif",
    align: "center",
})
const subTitleStyle = new PIXI.TextStyle({
    fontSize: 16,
    fill: '#828384',
    lineHeight: 22,
    fontFamily: "Montserrat, sans-serif",
    align: "center",
})

export class RecoverModalComponent extends PIXI.Container {
    constructor() {
        super();

        this.bg = new PIXI.Graphics()
        this.setSize(this.width, this.height)
        drawRoundedRect(this.bg, 0,0,  sizes.web.nodalWidth, sizes.web.modalHeight, 30);
        this.bg.fill('#FFFFFF')
        this.bg.pivot.set(.5,.5)
        this.bg.position.set( - sizes.web.nodalWidth / 2, - sizes.web.modalHeight / 2)

        this.warningIcon = new PIXI.Sprite(PIXI.Texture.from('modalWarning'))
        this.warningIcon.setSize(105,104)
        this.warningIcon.anchor.set(.5)
        this.warningIcon.position.set(this.bg.width / 2, 0)

        const prize = gameData.getGameData('prize')
        this.title = new PIXI.Text({ text: 'Внимание', style: titleStyle });
        this.title.anchor.set(.5)
        this.title.position.set(this.bg.width / 2, 56 + this.title.height / 2)

        this.subTitle = new PIXI.Text({ text: `Игра была прервана. \n Твой выигрыш составляет: ${prize} BYN`, style: subTitleStyle });
        this.subTitle.anchor.set(.5)
        this.subTitle.position.set(this.bg.width / 2, 96 + this.subTitle.height / 2)

        this.btn = new PIXI.Sprite(PIXI.Texture.from('accessBtn'))
        this.btn.scale.set(.5,.5)
        this.btn.anchor.set(.5)
        this.btn.eventMode = 'static'
        this.btn.cursor = 'pointer'
        this.btn.position.set(this.bg.width / 2, this.bg.height)
        this.btn.on('pointerdown', this.onClose.bind(this))

        this.bg.addChild(this.title, this.warningIcon, this.subTitle, this.btn)
        this.addChild(this.bg)
    }

    onClose() {
        ApiService.finish().then(() => {
            gameData.setGameData('recover',  false)
            this.emit('IS_OPEN_EVENT', false)
        })
    }
}